import * as configKeysIds from '@/site-components/configuration-settings/configuration-key-ids';
import * as processTriggers from '@/store/modules/company/process-trigger-names';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'dispatchSettings',
	namespaced: true,
	state: {
		configKeyIds: configKeysIds,
		departments: {
			Service: {
				name: 'Service',
				displayName: 'Service'
			},
			QuickLube: {
				name: 'QuickLube',
				displayName: 'Quick Lube'
			},
			BodyShop: {
				name: 'BodyShop',
				displayName: 'Body Shop'
			}
		},
		repairOrderPriorityRecalc: processTriggers['RepairOrderPriorityRecalc']
	},
	mutations: {},
	actions: {
		// actions let us get to ({ state, getters, commit, dispatch }) {
	},
	getters: {
		repairOrderPriorityRecalc: state => {
			return state.repairOrderPriorityRecalc;
		},
		useServiceSettings: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}UseServiceSettings`
			];
		},
		useDefaultScore: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}UseDefaultScore`
			];
		},
		priorityStatusYes: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}PriorityStatusYes`
			];
		},
		priorityStatusWaiting: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}PriorityStatusWaiting`
			];
		},
		transportationLoaner: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}TransportationLoaner`
			];
		},
		transportationRental: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}TransportationRental`
			];
		},
		transportationShuttle: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}TransportationShuttle`
			];
		},
		pickup: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}Pickup`];
		},
		loanerPremiumPickup: state => departmentName => {
			return state.configKeyIds[
				`Dispatch${departmentName}LoanerPremiumPickup`
			];
		},
		premiumPickup: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}PremiumPickup`];
		},
		valet: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}Valet`];
		},
		arrivalPickup: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}ArrivalPickup`];
		},
		carryOver: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}CarryOver`];
		},
		recheck: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}Recheck`];
		},
		appointment: state => departmentName => {
			return state.configKeyIds[`Dispatch${departmentName}Appointment`];
		},
		departments: state => state.departments,
		allConfigKeyIds: state => {
			return [
				state.configKeyIds.DispatchServiceUseDefaultScore,
				state.configKeyIds.DispatchServicePriorityStatusYes,
				state.configKeyIds.DispatchServicePriorityStatusWaiting,
				state.configKeyIds.DispatchServiceTransportationLoaner,
				state.configKeyIds.DispatchServiceTransportationRental,
				state.configKeyIds.DispatchServiceTransportationShuttle,
				state.configKeyIds.DispatchServiceLoanerPremiumPickup,
				state.configKeyIds.DispatchServicePremiumPickup,
				state.configKeyIds.DispatchServiceArrivalPickup,
				state.configKeyIds.DispatchServiceCarryOver,
				state.configKeyIds.DispatchServiceRecheck,
				state.configKeyIds.DispatchServiceAppointment,
				state.configKeyIds.DispatchQuickLubeUseServiceSettings,
				state.configKeyIds.DispatchQuickLubeUseDefaultScore,
				state.configKeyIds.DispatchQuickLubePriorityStatusYes,
				state.configKeyIds.DispatchQuickLubePriorityStatusWaiting,
				state.configKeyIds.DispatchQuickLubeTransportationLoaner,
				state.configKeyIds.DispatchQuickLubeTransportationRental,
				state.configKeyIds.DispatchQuickLubeTransportationShuttle,
				state.configKeyIds.DispatchQuickLubeLoanerPremiumPickup,
				state.configKeyIds.DispatchQuickLubePremiumPickup,
				state.configKeyIds.DispatchQuickLubeArrivalPickup,
				state.configKeyIds.DispatchQuickLubeCarryOver,
				state.configKeyIds.DispatchQuickLubeRecheck,
				state.configKeyIds.DispatchQuickLubeAppointment,
				state.configKeyIds.DispatchBodyShopUseServiceSettings,
				state.configKeyIds.DispatchBodyShopUseDefaultScore,
				state.configKeyIds.DispatchBodyShopPriorityStatusYes,
				state.configKeyIds.DispatchBodyShopPriorityStatusWaiting,
				state.configKeyIds.DispatchBodyShopTransportationLoaner,
				state.configKeyIds.DispatchBodyShopTransportationRental,
				state.configKeyIds.DispatchBodyShopTransportationShuttle,
				state.configKeyIds.DispatchBodyShopLoanerPremiumPickup,
				state.configKeyIds.DispatchBodyShopPremiumPickup,
				state.configKeyIds.DispatchBodyShopArrivalPickup,
				state.configKeyIds.DispatchBodyShopCarryOver,
				state.configKeyIds.DispatchBodyShopRecheck,
				state.configKeyIds.DispatchBodyShopAppointment,
				state.configKeyIds.DispatchServicePickup,
				state.configKeyIds.DispatchServiceValet,
				state.configKeyIds.DispatchQuickLubePickup,
				state.configKeyIds.DispatchQuickLubeValet,
				state.configKeyIds.DispatchBodyShopPickup,
				state.configKeyIds.DispatchBodyShopValet
			];
		},
		scoreConfigKeyIdsByDept: (state, getters) => departmentName => {
			return [
				getters.priorityStatusYes(departmentName),
				getters.priorityStatusWaiting(departmentName),
				getters.transportationLoaner(departmentName),
				getters.transportationRental(departmentName),
				getters.transportationShuttle(departmentName),
				getters.pickup(departmentName),
				getters.loanerPremiumPickup(departmentName),
				getters.premiumPickup(departmentName),
				getters.valet(departmentName),
				getters.arrivalPickup(departmentName),
				getters.carryOver(departmentName),
				getters.recheck(departmentName),
				getters.appointment(departmentName)
			];
		}
	}
};
